import { Collapse } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { SizingMultiplier } from './sizing-multiplier.constant';
import { Paper } from './surfaces/paper/paper.component';
import { Typography } from './typography/typography.component';

type NoStoresFoundProps = {
  open: boolean;
  delay?: number;
};

export const NoStoresFound: React.FC<NoStoresFoundProps> = memo((props) => {
  const { open, delay = 0 } = props;
  const [opened, setOpen] = useState(false);

  useEffect(() => {
    if (open === opened) {
      return;
    }
    const exec = async () => {
      if (open) {
        setOpen(true);
      } else {
        // Wait till parent animation finished
        await new Promise((res) => {
          setTimeout(res, delay);
        });
        setOpen(false);
      }
    };
    exec();
  }, [delay, open, opened]);

  return (
    <Collapse in={opened} timeout="auto" unmountOnExit>
      <Paper
        elevation={2}
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderRadius: 4,
          py: theme.spacing(SizingMultiplier.lg),
          mb: `calc(var(--ion-safe-area-bottom) + ${theme.spacing(SizingMultiplier.sm)})`,
        })}>
        <Typography variant="h5" gutterBottom>
          <FormattedMessage
            id="storeLocator:noStoresFoundPopupTitle"
            defaultMessage="No results"
            description="Store locator: 'No stores found' popup title"
          />
        </Typography>
        <Typography variant="body2" align="center">
          <FormattedMessage
            id="storeLocator:noStoresFoundPopupDescription"
            defaultMessage="Please try a different search."
            description="Store locator: 'No stores found' popup description"
          />
        </Typography>
      </Paper>
    </Collapse>
  );
});
